import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  GridList,
  GridListTile,
  GridListTileBar,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { MediaGridData, YoutubeData } from '../../../Content';
import React, { useCallback, useState } from 'react';

import { PlayCircleOutline } from '@material-ui/icons';
import { YoutubeContent } from './YoutubeContent';

interface MediaGridContentProps {
  content: MediaGridData;
}

export const MediaGridContent: React.FC<MediaGridContentProps> = ({
  content,
}) => {
  const [activeVideo, setActiveVideo] = useState<YoutubeData | null>(null);

  const theme = useTheme();
  const BP_SM = useMediaQuery(theme.breakpoints.up('sm'));
  const BP_MD = useMediaQuery(theme.breakpoints.up('md'));

  const createMediaGrid = useCallback(() => {
    return (
      <GridList
        cellHeight={
          (BP_MD ? 220 : 160) * (content.videos.length <= 3 ? 1.5 : 1)
        }
        cols={BP_SM ? Math.min(content.videos.length, 3) : 1}
        spacing={10}
      >
        {content.videos.map((video, index) => (
          <GridListTile key={video.youtubeID} cols={1}>
            <img
              src={video.thumbnail}
              alt={video.title}
              onClick={() => setActiveVideo(video)}
              style={{ cursor: 'pointer' }}
            />
            <GridListTileBar
              title={video.title}
              actionIcon={
                <IconButton onClick={() => setActiveVideo(video)}>
                  <PlayCircleOutline style={{ color: 'white' }} />
                </IconButton>
              }
            />
          </GridListTile>
        ))}
      </GridList>
    );
  }, [content.videos, setActiveVideo, BP_SM, BP_MD]);

  const createVideoPlayer = useCallback(() => {
    return (
      activeVideo && (
        <Dialog
          open={true}
          scroll="body"
          onClose={() => setActiveVideo(null)}
          fullWidth={true}
          maxWidth="lg"
        >
          <DialogContent>
            <DialogTitle></DialogTitle>
            <YoutubeContent content={activeVideo} />
            <DialogActions>
              <Button onClick={() => setActiveVideo(null)}>Back</Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      )
    );
  }, [activeVideo, setActiveVideo]);

  return (
    <div>
      {createMediaGrid()}
      {createVideoPlayer()}
    </div>
  );
};
